import { LoanForm } from "./LoanApplication";

export const brokerForm1 = [
  {
    field: "general",
    arr: [
      {
        section: "Broker Contact Information",
        arr: [
          {
            title: "Broker Company Name",
            field: "brokerContactInfo_BrokerCompanyName",
            type: "text",
            className: "col-6",
          },
          {
            title: "License No.",
            field: "brokerContactInfo_LicenseNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Broker Name",
            field: "brokerContactInfo_BrokerName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Additional Contact",
            field: "brokerContactInfo_AdditionalContact",
            type: "text",
            className: "col-6",
          },
          {
            title: "Address",
            field: "brokerContactInfo_Address",
            type: "textarea",
            className: "col-12",
          },
          // {
          //   title: "City",
          //   field: "brokerContactInfo_City",
          //   type: "text",
          //   className: "col-4",
          // },
          // {
          //   title: "State",
          //   field: "brokerContactInfo_State",
          //   type: "text",
          //   className: "col-4",
          // },
          // {
          //   title: "Zip",
          //   field: "brokerContactInfo_Zip",
          //   type: "text",
          //   className: "col-4",
          // },
          {
            title: "Work Phone",
            field: "brokerContactInfo_WorkPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "brokerContactInfo_Email",
            type: "text",
            className: "col-4",
          },
        ],
      },
      {
        section: "Borrower Information",
        arr: [
          {
            title: "Borrower Name",
            field: "borrowerInformation_BorrowerName",
            type: "text",
            className: "col-6",
          },
          {
            title: "SSN/Tax ID",
            field: "borrowerInformation_SSTaxID",
            type: "text",
            className: "col-6",
          },
          {
            title: "Co-Borrower Name",
            field: "borrowerInformation_CoBorrowerName",
            type: "text",
            className: "col-6",
          },
          {
            title: "SSN/Tax ID",
            field: "borrowerInformation_CoBorrowerSSTaxID",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower Vesting",
            field: "borrowerInformation_BorrowerVesting",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "borrowerInformation_Address",
            type: "textarea",
            className: "col-12",
          },
          // {
          //   title: "City",
          //   field: "borrowerInformation_City",
          //   type: "text",
          //   className: "col-3",
          // },
          // {
          //   title: "State",
          //   field: "borrowerInformation_State",
          //   type: "text",
          //   className: "col-3",
          // },
          // {
          //   title: "Zip",
          //   field: "borrowerInformation_Zip",
          //   type: "text",
          //   className: "col-3",
          // },
          // {
          //   title: "Email",
          //   field: "borrowerInformation_Email",
          //   type: "text",
          //   className: "col-3",
          // },
          {
            title: "Home Phone",
            field: "borrowerInformation_HomePhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "borrowerInformation_WorkPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Cell Phone",
            field: "borrowerInformation_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Signor/Capacity (if borrower is a company)",
            field: "borrowerInformation_SignorCapacity",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "Loan Information",
        arr: [
          {
            title: "1ST TD/MTG",
            field: "loanInformation_1stTDMTG",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "2ND TD/MTG",
            field: "loanInformation_2ndTDMTG",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Other",
            field: "loanInformation_Other",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Interest Only",
            field: "loanInformation_InterestOnly",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Partial Amortization",
            field: "loanInformation_PartialAmortization",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Full Amortization",
            field: "loanInformation_FullAmortization",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Loan Amount",
            field: "loanInformation_LoanAmount",
            type: "text",
            className: "col-12",
          },

          {
            title: "Prepayment Penalty",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-6",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
          {
            title: "Prepay Expires",
            field: "loanInformation_PrepayExpires",
            type: "text",
            className: "col-6",
          },
          {
            title: "Additional Prepayment Penalty Terms",
            field: "loanInformation_AdditionalPrepaymentPenaltyTerms",
            type: "text",
            className: "col-12",
          },
          {
            title: "Loan Term (Months)",
            field: "loanInformation_LoanTerm",
            type: "text",
            className: "col-6",
          },
          {
            title: "Payment Frequency",
            field: "loanInformation_PaymentFrequency",
            type: "text",
            className: "col-6",
          },
          {
            title: "Interest Rate %",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-3",
          },
          {
            title: "Sold Rate %",
            field: "loanInformation_SoldRate",
            type: "text",
            className: "col-3",
          },
          {
            title: "Late Charge %",
            field: "loanInformation_LateChargePercent",
            type: "text",
            className: "col-3",
          },
          {
            title: "No. of Days Until Late",
            field: "loanInformation_NoOfDaysUntilLate",
            type: "text",
            className: "col-3",
          },
          {
            title: "Late Fee Distribution - Lender %",
            field: "loanInformation_LateFeeDistributionLender",
            type: "text",
            className: "col-4",
          },
          {
            title: "Late Fee Distribution - Servicer %",
            field: "loanInformation_LateFeeDistributionServicer",
            type: "text",
            className: "col-4",
          },
          {
            title: "Late Fee Distribution - Other %",
            field: "loanInformation_LateFeeDistributionOther",
            type: "text",
            className: "col-4",
          },
          {
            title: "Property Address",
            field: "loanInformation_PropertyAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "Property Type",
            field: "loanInformation_PropertyType",
            type: "text",
            className: "col-4",
          },
          {
            title: "Property Value",
            field: "loanInformation_PropertyValue",
            type: "text",
            className: "col-4",
          },
          {
            title: "Valuation Provided By",
            field: "loanInformation_ValuationProvidedBy",
            type: "text",
            className: "col-4",
          },
          {
            title: "Loan Servicer",
            field: "loanInformation_LoanServicer",
            type: "text",
            className: "col-12",
          },
          {
            title: "Escrow Company",
            field: "loanInformation_EscrowCompany",
            type: "text",
            className: "col-12",
          },
          {
            title: "Estimated Closing Date",
            field: "loanInformation_EstimatedClosingDate",
            type: "text",
            className: "col-6",
          },
          {
            title: "First Payment Due Date",
            field: "loanInformation_FirstPaymentDueDate",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Type - Purchase",
            field: "loanInformation_LoanTypePurchase",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Loan Type - Refinance",
            field: "loanInformation_LoanTypeRefinance",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Loan Type - Residential",
            field: "loanInformation_LoanTypeResidential",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Loan Type - Commercial",
            field: "loanInformation_LoanTypeCommercial",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Loan Type - Other",
            field: "loanInformation_LoanTypeOther",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Owner Occupied",
            field: "loanInformation_OwnerOccupied",
            type: "radio",
            className: "col-12 mt-3",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
        ],
      },
      {
        section: (
          <>
            Additional Terms: Please use the space below for any special terms,
            conditions or instructions.
          </>
        ),
        arr: [
          {
            title:
              "Please use the space below for any special terms, conditions or instructions",
            field:
              "please_use_the_space_below_for_any_special_terms_conditions_or_instructions",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: (
          <>
            Loan Fees: Please provide loan fees below or provide a broker fee
            sheet
          </>
        ),
        arr: [
          {
            title: "Broker Points/Origination Fee",
            field: "loanFees_BrokerPointsOriginationFee",
            type: "text",
            className: "col-6",
          },
          {
            title: "Referral Fee",
            field: "loanFees_ReferralFee",
            type: "text",
            className: "col-6",
          },
          {
            title: "Processing Fee",
            field: "loanFees_ProcessingFee",
            type: "text",
            className: "col-4",
          },
          {
            title: "Underwriting Fee",
            field: "loanFees_UnderwritingFee",
            type: "text",
            className: "col-4",
          },
          {
            title: "Admin Fee",
            field: "loanFees_AdminFee",
            type: "text",
            className: "col-4",
          },
          {
            title: "Other Fees",
            field: "loanFees_OtherFees",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div className="container mt-3">
                <p className="fw-bold">Required Documents:</p>
                <ul className="">
                  <li className="fw-bold">1003 Mortgage Application</li>
                  <li className="fw-bold">Preliminary Title Report</li>
                  <li className="fw-bold">Estimated HUD or Fee Breakdown</li>
                  <li className="">
                    <b>Corporate Documents</b> (if applicable) - verification of
                    state of organization and authorized signer/capacity
                  </li>
                  <li className="fw-bold">Valuation Documentation</li>
                  <li className="fw-bold">Senior Lien if applicable</li>
                </ul>
              </div>
            ),
          },
        ],
      },
      {
        section: (
          <div>
            <h4 className="text-center fw-bold">Lender Identification</h4>
            <p>Lender Information</p>
          </div>
        ),
        arr: [
          {
            title: "Lender Name",
            field: "lenderIdentification_LenderName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Vesting",
            field: "lenderIdentification_Vesting",
            type: "text",
            className: "col-6",
          },
          {
            title: "Mailing Address",
            field: "lenderIdentification_MailingAddress",
            type: "text",
            className: "col-6",
          },
          {
            title: "Home Phone",
            field: "lenderIdentification_HomePhone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "lenderIdentification_WorkPhone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "lenderIdentification_CellPhone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email",
            field: "lenderIdentification_Email",
            type: "text",
            className: "col-6",
          },
          {
            title: "Social Security/Tax ID No",
            field: "lenderIdentification_SocialSecurityTaxIDNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount Invested",
            field: "lenderIdentification_AmountInvested",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 2",
        arr: [
          {
            title: "Lender Name",
            field: "lenderIdentification_LenderName2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Vesting",
            field: "lenderIdentification_Vesting2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Mailing Address",
            field: "lenderIdentification_MailingAddress2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Home Phone",
            field: "lenderIdentification_HomePhone2",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "lenderIdentification_WorkPhone2",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "lenderIdentification_CellPhone2",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email",
            field: "lenderIdentification_Email2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Social Security/Tax ID No",
            field: "lenderIdentification_SocialSecurityTaxIDNo2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount Invested",
            field: "lenderIdentification_AmountInvested2",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 3",
        arr: [
          {
            title: "Lender Name",
            field: "lenderIdentification_LenderName3",
            type: "text",
            className: "col-6",
          },
          {
            title: "Vesting",
            field: "lenderIdentification_Vesting3",
            type: "text",
            className: "col-6",
          },
          {
            title: "Mailing Address",
            field: "lenderIdentification_MailingAddress3",
            type: "text",
            className: "col-6",
          },
          {
            title: "Home Phone",
            field: "lenderIdentification_HomePhone3",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "lenderIdentification_WorkPhone3",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "lenderIdentification_CellPhone3",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email",
            field: "lenderIdentification_Email3",
            type: "text",
            className: "col-6",
          },
          {
            title: "Social Security/Tax ID No",
            field: "lenderIdentification_SocialSecurityTaxIDNo3",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount Invested",
            field: "lenderIdentification_AmountInvested3",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 4",
        arr: [
          {
            title: "Lender Name",
            field: "lenderIdentification_LenderName4",
            type: "text",
            className: "col-6",
          },
          {
            title: "Vesting",
            field: "lenderIdentification_Vesting4",
            type: "text",
            className: "col-6",
          },
          {
            title: "Mailing Address",
            field: "lenderIdentification_MailingAddress4",
            type: "text",
            className: "col-6",
          },
          {
            title: "Home Phone",
            field: "lenderIdentification_HomePhone4",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "lenderIdentification_WorkPhone4",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "lenderIdentification_CellPhone4",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email",
            field: "lenderIdentification_Email4",
            type: "text",
            className: "col-6",
          },
          {
            title: "Social Security/Tax ID No",
            field: "lenderIdentification_SocialSecurityTaxIDNo4",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount Invested",
            field: "lenderIdentification_AmountInvested4",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 5",
        arr: [
          {
            title: "Lender Name",
            field: "lenderIdentification_LenderName5",
            type: "text",
            className: "col-6",
          },
          {
            title: "Vesting",
            field: "lenderIdentification_Vesting5",
            type: "text",
            className: "col-6",
          },
          {
            title: "Mailing Address",
            field: "lenderIdentification_MailingAddress5",
            type: "text",
            className: "col-6",
          },
          {
            title: "Home Phone",
            field: "lenderIdentification_HomePhone5",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "lenderIdentification_WorkPhone5",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "lenderIdentification_CellPhone5",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email",
            field: "lenderIdentification_Email5",
            type: "text",
            className: "col-6",
          },
          {
            title: "Social Security/Tax ID No",
            field: "lenderIdentification_SocialSecurityTaxIDNo5",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount Invested",
            field: "lenderIdentification_AmountInvested5",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            content: (
              <p className="text-center fw-bold">
                Please submit the following documents along with your order to:
                <a href="mailto:docs@slsbox.com"> docs@slsbox.com</a>
                {/* <b>
                  * 1003 Mortgage Application and Borrower W-9 * Preliminary
                  Title Report * Estimated HUD or Fee Breakdown * Corporate
                  Documents if applicable (verification of state of organization
                  and authorized signer/capacity) * Valuation Documentation *
                  Senior Lien info if applicable
                </b> */}
              </p>
            ),
            type: "content",
            className: "col-12",
          },
        ],
      },
    ],
  },
];
export const brokerForm2 = [
  {
    field: "general",
    arr: [
      {
        section: "Client Contact Information (for the loan file order)",
        arr: [
          {
            title: "Company Name",
            field: "clientContactInfo_ContactCompanyName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Select One",
            field: "selectOne",
            type: "radio",
            options: [
              { title: "Broker", value: "broker" },
              { title: "Direct", value: "direct" },
              { title: "Other", value: "other" },
            ],
            className: "col-6",
          },
          {
            title: "Address",
            field: "clientContactInfo_Address",
            type: "textarea",
            className: "col-6",
          },
          {
            title: "SLS Account No. (Existing Clients)",
            field: "slsAccountNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "City",
            field: "clientContactInfo_City",
            type: "text",
            className: "col-4",
          },
          {
            title: "State",
            field: "clientContactInfo_State",
            type: "text",
            className: "col-4",
          },
          {
            title: "Zip",
            field: "clientContactInfo_Zip",
            type: "text",
            className: "col-4",
          },
          {
            title: "Contact Name",
            field: "clientContactInfo_ContactName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Additional Contact",
            field: "clientContactInfo_AdditionalContact",
            type: "text",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "clientContactInfo_WorkPhone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "clientContactInfo_WorkPhone2",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "clientContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "clientContactInfo_CellPhone2",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email",
            field: "clientContactInfo_Email",
            type: "text",
            className: "col-6",
          },
          {
            title: "Email",
            field: "clientContactInfo_Email2",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Borrower Information",
        arr: [
          {
            title: "Borrower Name",
            field: "borrowerInformation_BorrowerName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Contact Name (First & Last)",
            field: "borrowerInformation_ContactName",
            type: "text",
            className: "col-6",
          },
          {
            title: "SSN/Tax ID",
            field: "borrowerInformation_SSTaxID",
            type: "text",
            className: "col-6",
          },
          {
            title: "Co-Borrower Name",
            field: "borrowerInformation_CoBorrowerName",
            type: "text",
            className: "col-6",
          },
          {
            title: "SSN / TAX ID",
            field: "borrowerInformation_SSTaxID2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Mailing Address",
            field: "borrowerInformation_Address",
            type: "text",
            className: "col-12",
          },
          // {
          //   title: "City",
          //   field: "borrowerInformation_City",
          //   type: "text",
          //   className: "col-4",
          // },
          // {
          //   title: "State",
          //   field: "borrowerInformation_State",
          //   type: "text",
          //   className: "col-4",
          // },
          // {
          //   title: "Zip",
          //   field: "borrowerInformation_Zip",
          //   type: "text",
          //   className: "col-4",
          // },
          {
            title: "Home Phone",
            field: "borrowerInformation_HomePhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "borrowerInformation_WorkPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Cell Phone",
            field: "borrowerInformation_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          // {
          //   title: "Contact Name (if borrower is a company)",
          //   field: "borrowerInformation_ContactNameIfCompany",
          //   type: "text",
          //   className: "col-6",
          // },
          // {
          //   title: "Email",
          //   field: "borrowerInformation_Email",
          //   type: "text",
          //   className: "col-6",
          // },
          {
            title: "Borrower Email",
            field: "borrowerInformation_borrowerEmail",
            type: "email",
            className: "col-6",
          },
          {
            title: "Co-Borrower Email",
            field: "borrowerInformation_coBorrowerEmail",
            type: "email",
            className: "col-6",
          },
        ],
      },
      {
        section:
          "Loan Information (for additional properties, please use the Additional Property form)",
        // arr: [
        //   {
        //     title: "1ST TD/MTG",
        //     field: "loanInformation_1stTDMTG",
        //     type: "checkbox",
        //     className: "col-4",
        //   },
        //   {
        //     title: "2ND TD/MTG",
        //     field: "loanInformation_2ndTDMTG",
        //     type: "checkbox",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Other",
        //     field: "loanInformation_Other",
        //     type: "checkbox",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Property Address",
        //     field: "loanInformation_PropertyAddress",
        //     type: "text",
        //     className: "col-12",
        //   },
        //   {
        //     title: "Interest Only",
        //     field: "loanInformation_InterestOnly",
        //     type: "checkbox",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Partial Amortization",
        //     field: "loanInformation_PartialAmortization",
        //     type: "checkbox",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Full Amortization",
        //     field: "loanInformation_FullAmortization",
        //     type: "checkbox",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Prepayment Penalty",
        //     field: "loanInformation_PrepaymentPenalty",
        //     type: "radio",
        //     className: "col-6",
        //     options: [
        //       { title: "Yes", value: "yes" },
        //       { title: "No", value: "no" },
        //     ],
        //   },
        //   {
        //     title: "Prepay Expires",
        //     field: "loanInformation_PrepayExpires",
        //     type: "text",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Term",
        //     field: "loanInformation_LoanTerm",
        //     type: "text",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Payment Frequency",
        //     field: "loanInformation_PaymentFrequency",
        //     type: "text",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Interest Rate",
        //     field: "loanInformation_InterestRate",
        //     type: "text",
        //     className: "col-3",
        //   },
        //   {
        //     title: "Sold Rate",
        //     field: "loanInformation_SoldRate",
        //     type: "text",
        //     className: "col-3",
        //   },
        //   {
        //     title: "Late Charge %",
        //     field: "loanInformation_LateChargePercent",
        //     type: "text",
        //     className: "col-3",
        //   },
        //   {
        //     title: "No. of Days Until Late",
        //     field: "loanInformation_NoOfDaysUntilLate",
        //     type: "text",
        //     className: "col-3",
        //   },
        //   {
        //     title: "Late Fee Distribution - Lender",
        //     field: "loanInformation_LateFeeDistribution",
        //     type: "text",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Late Fee Distribution - SLS %",
        //     field: "loanInformation_LateFeeDistributionSLS",
        //     type: "text",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Late Fee Distribution - Other",
        //     field: "loanInformation_LateFeeDistributionOther",
        //     type: "text",
        //     className: "col-4",
        //   },
        //   {
        //     title: "Servicing Fee Per Lender Per Month $",
        //     field: "loanInformation_ServicingFeePerLenderPerMonth",
        //     type: "text",
        //     className: "col-6",
        //   },
        //   {
        //     title: "File Setup Fee $",
        //     field: "loanInformation_FileSetupFee",
        //     type: "text",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Servicing Paid By Lender",
        //     field: "loanInformation_ServicingPaidByLender",
        //     type: "checkbox",
        //     className: "col-3",
        //   },
        //   {
        //     title: "Other",
        //     field: "loanInformation_ServicingPaidByLenderOther",
        //     type: "text",
        //     className: "col-3",
        //   },
        //   {
        //     title: "File Setup Paid By Lender",
        //     field: "loanInformation_FileSetupPaidByLender",
        //     type: "checkbox",
        //     className: "col-3",
        //   },
        //   {
        //     title: "Other",
        //     field: "loanInformation_FileSetupPaidByLenderOther",
        //     type: "text",
        //     className: "col-3",
        //   },
        //   {
        //     title: "Additional Information",
        //     field: "loanInformation_AdditionalInformation",
        //     type: "text",
        //     className: "col-12",
        //   },
        //   {
        //     title: "Loan Status - Foreclosure",
        //     field: "loan_Status_Foreclosure",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Status - Bankruptcy",
        //     field: "loan_Status_Bankruptcy",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Status - Loan Modification",
        //     field: "loan_Status_Loan_Modification",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Status - Forbearance Plan",
        //     field: "loan_Status_Forbearance_Plan",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Type - Purchase",
        //     field: "loan_type_purchase",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Type - Refinance",
        //     field: "loan_type_refinance",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Type - Residential",
        //     field: "loan_type_residential",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Type - Commercial",
        //     field: "loan_type_commercial",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Loan Type - Other",
        //     field: "loan_type_other",
        //     type: "checkbox",
        //     className: "col-6",
        //   },
        //   {
        //     title: "Owner Occupied",
        //     field: "loanInformation_OwnerOccupied",
        //     type: "radio",
        //     className: "col-12 mt-3",
        //     options: [
        //       { title: "Yes", value: "yes" },
        //       { title: "No", value: "no" },
        //     ],
        //   },
        // ],
        arr: [
          {
            title: "Loan Number",
            field: "loanInformation_loanNumber",
            type: "text",
            className: "col-4",
          },
          {
            title: "Interest Rate",
            field: "loanInformation_interestRate",
            type: "text",
            className: "col-4",
          },
          {
            title: "Sold Rate",
            field: "loanInformation_soldRate",
            type: "text",
            className: "col-4",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <p>Skim Splits (Difference of Note Rate vs Sold Rate)</p>
              </div>
            ),
          },
          {
            title: "Pay to SLS Account No.",
            field: "loanInformation_payToSlsAccountNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "% of Skim",
            field: "loanInformation_percentOfSkim",
            type: "text",
            className: "col-6",
          },
          {
            title: "Pay to SLS Account No.",
            field: "loanInformation_payToSlsAccountNo2",
            type: "text",
            className: "col-6",
          },
          {
            title: "% of Skim",
            field: "loanInformation_percentOfSkim2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Amount",
            field: "loanInformation_loanAmount",
            type: "text",
            className: "col-4",
          },
          {
            title: "Payment Frequency",
            field: "loanInformation_paymentFrequency",
            type: "select",
            options: [
              { label: "Monthly", value: "monthly" },
              { label: "Yearly", value: "yearly" },
            ],
            className: "col-4",
          },
          {
            title: "Loan Priority",
            field: "loanInformation_loanPriority",
            type: "select",
            className: "col-4",
            options: [
              { label: "1st", value: "1st" },
              { label: "2nd", value: "2nd" },
              { label: "3rd", value: "3rd" },
              { label: "4th", value: "4th" },
              { label: "5th", value: "5th" },
            ],
          },
          {
            title: "Interest Charged on",
            field: "loanInformation_interestChargedOn",
            type: "radio",
            options: [
              { title: "Full Loan Amount", value: "fullLoanAmount" },
              {
                title:
                  "UPB (unpaid principal balance if loan not fully funded)",
                value: "upb",
              },
            ],
            className: "col-6",
          },
          {
            title: "Current UPB",
            field: "loanInformation_currentUpb",
            type: "number",
            className: "col-6",
          },
          {
            title: "Funding Date",
            field: "loanInformation_fundingDate",
            type: "date",
            className: "col-4",
          },
          {
            title: "1st Payment Date",
            field: "loanInformation_firstPaymentDate",
            type: "date",
            className: "col-4",
          },
          {
            title: "Maturity Date",
            field: "loanInformation_maturityDate",
            type: "date",
            className: "col-4",
          },
          {
            title: "Property Address",
            field: "loanInformation_propertyAddress",
            type: "textarea",
            className: "col-8",
          },
          {
            title: "Property Type",
            field: "loanInformation_propertyType",
            type: "select",
            options: [
              { label: "SFR", value: "sfr" },
              { label: "Condo", value: "condo" },
              { label: "Duplex", value: "duplex" },
              { label: "Vacant Land", value: "vacantLand" },
              { label: "Office Building", value: "officeBuilding" },
              { label: "Construction", value: "construction" },
              { label: "Commercial", value: "commercial" },
              { label: "Multi-Family", value: "multiFamily" },
              { label: "Townhouse", value: "townhouse" },
              { label: "Other", value: "other" },
            ],
            className: "col-4",
          },
          {
            title: "Property APN",
            field: "loanInformation_propertyApn",
            type: "text",
            className: "col-4",
          },
          {
            title: "Interest Calculation",
            field: "loanInformation_interestCalculation",
            type: "select",
            options: [
              { label: "360/30", value: "36030" },
              { label: "360/Actual", value: "360Actual" },
              { label: "365/30", value: "36530" },
              { label: "365/Actual", value: "365Actual" },
            ],
            className: "col-4",
          },
          {
            title: "Occupancy",
            field: "loanInformation_occupancy",
            type: "text",
            className: "col-4",
          },
          {
            title: "Property Value",
            field: "loanInformation_propertyValue",
            type: "text",
            className: "col-4",
          },
          {
            title: "Late Charge %",
            field: "loanInformation_lateChargePercent",
            type: "text",
            className: "col-4",
          },
          {
            title: "Days Until Late",
            field: "loanInformation_daysUntilLate",
            type: "text",
            className: "col-4",
          },
          {
            title: "Loan Type",
            field: "loanInformation_loanType",
            type: "select",
            className: "col-4",
            options: [
              { label: "Full Amortization", value: "fullAmortization" },
              { label: "Interest Only", value: "interestOnly" },
              { label: "Partial Amortization", value: "partialAmortization" },
            ],
          },
          {
            title: "Lender Late Fee%",
            field: "loanInformation_lenderLateFeePercent",
            type: "text",
            className: "col-4",
          },
          {
            title: "Originator/Client Late Fee%",
            field: "loanInformation_originatorClientLateFeePercent",
            type: "text",
            className: "col-4",
          },
          {
            title: "Servicing Paid by",
            field: "loanInformation_servicingPaidBy",
            type: "radio",
            options: [
              { title: "Lender", value: "lender" },
              { title: "Borrower", value: "borrower" },
              { title: "Other", value: "other" },
            ],
            className: "col-8",
          },
          {
            title: "If Other",
            field: "loanInformation_other",
            type: "text",
            className: "col-4",
          },
        ],
      },
      {
        section:
          "SLS Held Funds - All funds must be made payable to Superior Loan Servicing",
        arr: [
          {
            title: "Interest Reserves",
            field: "slsHeldFunds_InterestReserves",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Interest Reserves – Amount",
            field: "slsHeldFunds_InterestReservesAmount",
            type: "text",
            className: "col-4",
          },
          {
            title: "# of Months",
            field: "slsHeldFunds_NumberOfMonths",
            type: "text",
            className: "col-4",
          },
          {
            title: "Construction/Rehab Hold Back",
            field: "slsHeldFunds_RehabConstructionReserves",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Construction/Rehab Hold Back Amount",
            field: "slsHeldFunds_RehabConstructionReservesAmount",
            type: "number",
            className: "col-8",
          },
          // {
          //   title: "# of Draws",
          //   field: "slsHeldFunds_NumberOfDraws",
          //   type: "text",
          //   className: "col-6",
          // },
          {
            title: "Other",
            field: "slsHeldFunds_Other",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Other – Amount",
            field: "slsHeldFunds_OtherAmount",
            type: "number",
            className: "col-4",
          },
          {
            title: "Description",
            field: "slsHeldFunds_Description",
            type: "textarea",
            className: "col-4",
          },
          {
            title: "Additional Funds not held by SLS (please describe)",
            field: "slsHeldFunds_additionalFundsInfo",
            type: "textarea",
            className: "col-12",
          },
          // {
          //   title: "Impound Account",
          //   field: "slsHeldFunds_ImpoundAccount",
          //   type: "radio",
          //   className: "col-12 mt-3",
          //   options: [
          //     {
          //       title: "Yes ($45 Setup Fee/ $20 per month/per loan)",
          //       value: "yes",
          //     },
          //     { title: "No", value: "no" },
          //   ],
          // },
          // {
          //   title: "Property Tax Amount – 1st Installment",
          //   field: "slsHeldFunds_PropertyTaxAmountFirstInstallment",
          //   type: "text",
          //   className: "col-6",
          // },
          // {
          //   title: "Property Tax Amount – 2nd Installment",
          //   field: "slsHeldFunds_PropertyTaxAmountSecondInstallment",
          //   type: "text",
          //   className: "col-6",
          // },
          // {
          //   title: "Property Insurance – Annual Premium",
          //   field: "slsHeldFunds_PropertyInsuranceAnnualPremium",
          //   type: "text",
          //   className: "col-12",
          // },
        ],
      },
      {
        section: "Assignment Information",
        className: "col-12",
        arr: [
          {
            title: "Assignment Date",
            field: "assignmentInformation_AssignmentDate",
            type: "date",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <p>Skim Splits (Difference of Note Rate vs Sold Rate)</p>
              </div>
            ),
          },
          {
            title: "Pay to SLS Account No.",
            field: "assignmentInformation_payToSlsAccountNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "% of Skim",
            field: "assignmentInformation_percentOfSkim",
            type: "text",
            className: "col-6",
          },
          {
            title: "Pay to SLS Account No.",
            field: "assignmentInformation_payToSlsAccountNo2",
            type: "text",
            className: "col-6",
          },
          {
            title: "% of Skim",
            field: "assignmentInformation_percentOfSkim2",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Impounds",
        arr: [
          {
            title: "Property Tax",
            field: "Impounds_propertyTax",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Insurance",
            field: "Impounds_insurance",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Cushion Collected $",
            field: "Impounds_cushionCollected",
            type: "text",
            className: "col-6",
          },
          {
            title: "County",
            field: "Impounds_county",
            type: "text",
            className: "col-12",
          },
          {
            title: "Next Installment Due",
            field: "Impounds_nextInstallmentDue",
            type: "text",
            className: "col-12",
          },
          {
            field: "Impounds_installmentDueDates",
            title: "Installment Due Dates",
            type: "date",
            className: "col-3",
          },
          {
            field: "Impounds_installmentDueDates2",
            title: "Installment Due Dates",
            type: "date",
            className: "col-3",
          },
          {
            field: "Impounds_installmentDueDates3",
            title: "Installment Due Dates",
            type: "date",
            className: "col-3",
          },
          {
            field: "Impounds_installmentDueDates4",
            title: "Installment Due Dates",
            type: "date",
            className: "col-3",
          },
          {
            title: "Any additional agency information list below",
            field: "Impounds_additionalAgencyInfo",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "Notes",
            field: "Impounds_notes",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            title: "Interest Reserves – Amount",
            field: "slsHeldFunds_InterestReservesAmount",
            content: (
              <div>
                <p className="fw-bold text-center">
                  Please submit the following documents along with your order to{" "}
                  <a href="mailto:boarding@slsbox.com">boarding@slsbox.com</a>.
                </p>
                <div className="container mt-3 fw-bold">
                  <p>Required Documents</p>
                  <ul className="">
                    <li className="">Note</li>
                    <li className="">
                      Deed of Trust or Mortgage
                    </li>
                    <li className="">Final Closing Statement</li>
                    <li className="">Evidence of Insurance</li>
                    <li className="">
                      All other collection related documents:
                    </li>
                    <ul className="list-group ms-5">
                      <li className="">Personal Guaranty</li>
                      <li className="">
                        Riders or Addendums to the Note or Deed of Trust
                      </li>
                      <li className="">
                        Back End Fee Agreements
                      </li>
                      <li className="">
                        Rehab/Construction Draw Agreements
                      </li>
                    </ul>
                    <li className="">Copies of Tax Bill(s)</li>
                    <li className="">
                      Estimated Escrow Analysis
                    </li>
                  </ul>
                </div>
              </div>
            ),
            type: "content",
            className: "col-12",
          },
        ],
      },
    ],
  },
];
export const brokerForm3 = [
  {
    field: "general",
    arr: [
      {
        section: "Demand Request Form",
        arr: [
          {
            title: "Loan No.",
            field: "demandRequestForm_LoanNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower",
            field: "demandRequestForm_Borrower",
            type: "text",
            className: "col-6",
          },
          {
            title: "Property",
            field: "demandRequestForm_Property",
            type: "text",
            className: "col-6",
          },
          {
            title: "Company Requesting",
            field: "demandRequestForm_CompanyRequesting",
            type: "text",
            className: "col-6",
          },
          {
            title: "Title Company",
            field: "demandRequestForm_TitleCompany",
            type: "text",
            className: "col-6",
          },
          {
            title: "File No.",
            field: "demandRequestForm_FileNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Person Requesting",
            field: "demandRequestForm_PersonRequesting",
            type: "text",
            className: "col-6",
          },
          {
            title: "Escrow Company",
            field: "demandRequestForm_EscrowCompany",
            type: "text",
            className: "col-6",
          },
          {
            title: "Escrow Officier",
            field: "demandRequestForm_EscrowOfficier",
            type: "text",
            className: "col-6",
          },
          {
            title: "Escrow No.",
            field: "demandRequestForm_EscrowNo",
            type: "text",
            className: "col-6",
          },
          {
            title: "Estimated Closing Date",
            field: "demandRequestForm_EstClosingDate",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-6 d-flex align-items-center",
            content: (
              <>
                <p>
                  (Good through date of Demand, not to exceed 30 days)
                </p>
              </>
            ),
          },
          {
            title: "Email Demand To",
            field: "demandRequestForm_EmailDemandTo",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-3 d-flex align-items-center",
            content: (
              <>
                <p className="fw-bold">
                  $30 Demand Fee
                </p>
              </>
            ),
          },
          {
            title: "Additional $75 for RUSH Demand Request",
            field: "slsHeldFunds_InterestReserves",
            type: "checkbox",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12 px-5",
            content: (
              <>
                <p className="fw-bold">
                  All requests for demand must include a form of authorization
                  from the requesting Escrow and/or Title Company signed by the
                  borrower.
                </p>
                <p className="fw-bold">
                  SLS Demand Request form must be signed by the requesting
                  Escrow and/or Title Company. Please forward demand request to{" "}
                  <a href="mailto:demands@slsbox.com">demands@slsbox.com</a>.
                </p>
                <p className="fw-bold">
                  Superior Loan Servicing as agent for the beneficiary will
                  reconvey/release/discharge the lien upon receipt of payment in
                  full.{" "}
                  <span className="text-decoration-underline">
                    All funds must be made payable to Superior Loan Servicing.
                  </span>
                </p>
                <p>
                  By signing below I understand that by requesting a demand from
                  Superior Loan Servicing you hereby acknowledge that Superior
                  Loan Servicing, a loan servicer licensed in the State of
                  California through the California Bureau of Real Estate is the
                  authorized agent for the Beneficiary as per our servicing
                  agreement. All funds for payoff are to be made payable to
                  Superior Loan Servicing. Any use of the demand issued by
                  Superior Loan Servicing to pay to any other payee other than
                  Superior Loan Servicing is a violation of this agreement and
                  will be subject to legal recourse.
                </p>
              </>
            ),
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            title: "Signature",
            field: "demandRequestForm_Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name/Title",
            field: "demandRequestForm_PrintNameTitle",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12 px-5",
            content: (
              <>
                <p className="fw-bold">
                ****NOTE: This is NOT a Borrowers Authorization. Borrowers Authorization must be
                provided from requesting company. 
                </p>
              </>
            ),
          },
        ],
      },
    ],
  },
];
export const brokerForm4 = [
  {
    field: "",
    arr: [
      {
        section: "",
        arr: [
          {
            type: "content",
            content: (
              <>
                <h4 className="mt-5 text-center">
                  REQUEST FOR VERIFICATION OF RENT OR MORTGAGE
                </h4>
                <p className="px-5">
                  We have received an application for a loan from the applicant
                  listed below, to whom we understand you rent or have extended
                  a loan. <br />
                  <b>INSTRUCTIONS:</b> LENDER- Complete items 1 thru 8. Have
                  applicant(s) complete item 9. Forward directly to lender named
                  in item 1. LANDLORD/CREDITOR- Please complete Part II as
                  applicable. Sign and return directly to the lender named in
                  item 2.{" "}
                </p>{" "}
              </>
            ),
          },
        ],
      },
      {
        section: "Part I - Request",
        arr: [
          {
            title: "TO (Name and address of Landlord/Creditor)",
            field: "landlordCreditorNameAddress",
            type: "text",
            className: "col-6",
          },
          {
            title: "FROM (Name and address of lender)",
            field: "lenderNameAddress",
            type: "text",
            className: "col-6",
          },
          {
            title: "SIGNATURE OF LENDER",
            field: "lenderSignature",
            type: "text",
            className: "col-3",
          },
          {
            title: "TITLE",
            field: "lenderTitle",
            type: "text",
            className: "col-3",
          },
          {
            title: "DATE",
            field: "lenderDate",
            type: "date",
            className: "col-3",
          },
          {
            title: "LENDER'S NUMBER",
            field: "lendersNumber",
            type: "text",
            className: "col-3",
          },
          {
            content: <p className="fw-bold">INFORMATION TO BE VERIFIED</p>,
            field: "content1",
            type: "content",
            className: "col-12",
          },
          {
            title: "MORTGAGE",
            field: "mortgage",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "LAND CONTRACT",
            field: "landContract",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "RENTAL",
            field: "rental",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "OTHER",
            field: "other",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "PROPERTY ADDRESS",
            field: "propertyAddress",
            type: "text",
            className: "col-4",
          },
          {
            title: "ACCOUNT IN THE NAME OF",
            field: "accountName",
            type: "text",
            className: "col-4",
          },
          {
            title: "ACCOUNT NO.",
            field: "accountNumber",
            type: "text",
            className: "col-4",
          },
          {
            title: "NAME AND ADDRESS OF APPLICANT(S)",
            field: "applicantNameAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "SIGNATURE OF APPLICANT(S)",
            field: "applicantSignature1",
            type: "text",
            className: "col-6",
          },
          {
            title: "SIGNATURE OF APPLICANT(S)",
            field: "applicantSignature2",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            type: "content",
            content: (
              <h4 className="mt-5 mb-4">
                PART II – TO BE COMPLETED BY LANDLORD/CREDITOR
              </h4>
            ),
          },
        ],
      },
      {
        section: "RENTAL ACCOUNT",
        arr: [
          {
            title: "Tenant has rented since",
            field: "tenantRentedSince",
            type: "text",
            className: "col-12",
          },
          {
            title: "To",
            field: "tenantRentedUntil",
            type: "text",
            className: "col-12",
          },
          {
            title: "Amount of rent",
            field: "rentAmount",
            type: "text",
            className: "col-6",
          },
          {
            title: "Rent Frequency",
            field: "rentFrequency",
            type: "text",
            className: "col-6",
          },
          {
            title: "Is rent in arrears?",
            field: "rentInArrears",
            type: "radio",
            className: "col-12",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
          {
            title: "Number of times 30 days past due",
            field: "times30DaysPastDue",
            type: "text",
            className: "col-12",
          },
          {
            title: "Is account satisfactory?",
            field: "accountSatisfactory",
            type: "radio",
            className: "col-12",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
        ],
        className: "col-4",
      },
      {
        section: "MORTGAGE ACCOUNT",
        arr: [
          {
            title: "Date mortgage originated",
            field: "mortgageDateOriginated",
            type: "text",
            className: "col-12",
          },
          {
            title: "Original mortgage amount",
            field: "originalMortgageAmount",
            type: "number",
            className: "col-12",
          },
          {
            title: "Current mortgage balance",
            field: "currentMortgageBalance",
            type: "number",
            className: "col-12",
          },
          {
            title: "Monthly Payment P & I only",
            field: "monthlyPaymentPI",
            type: "number",
            className: "col-12",
          },
          {
            title: "Payment with taxes and ins.",
            field: "paymentWithTaxesIns",
            type: "number",
            className: "col-12",
          },
          {
            title: "Is mortgage current?",
            field: "isMortgageCurrent",
            type: "radio",
            className: "col-12",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
          {
            title: "Is mortgage assumable?",
            field: "isMortgageAssumable",
            type: "radio",
            className: "col-12",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
          {
            title: "Satisfactory account?",
            field: "mortgageAccountSatisfactory",
            type: "radio",
            className: "col-12",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
        ],
        className: "col-4",
      },
      {
        section: "LAND CONTRACT",
        arr: [
          {
            title: "Interest rate",
            field: "interestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mortgage Type FIXED",
            field: "mortgageTypeFixed",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Mortgage Type ARM",
            field: "mortgageTypeArm",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Mortgage Type FHA",
            field: "mortgageTypeFha",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Mortgage Type VA",
            field: "mortgageTypeVa",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Mortgage Type FNMA",
            field: "mortgageTypeFnma",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Mortgage Type CONV",
            field: "mortgageTypeConv",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Next pay date",
            field: "nextPayDate",
            type: "date",
            className: "col-12",
          },
          {
            title: "Number of late payments",
            field: "numberOfLatePayments",
            type: "number",
            className: "col-12",
          },
          {
            title: "Insurance agent",
            field: "insuranceAgent",
            type: "text",
            className: "col-12",
          },
        ],
        className: "col-4",
      },
      {
        section: "",
        arr: [
          {
            type: "content",
            content: (
              <p className="text-center">
                * Number of times account has been 30 days overdue in the last
                12 months
              </p>
            ),
          },
          {
            title:
              "ADDITIONAL INFORMATION WHICH MAY BE OF ASSISTANCE IN DETERMINING APPLICANT(S) CREDIT WORTHINESS",
            field: "additionalInfo",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "SIGNATURE OF CREDITOR",
            field: "signatureOfCreditor",
            type: "text",
            className: "col-4",
          },
          {
            title: "TITLE",
            field: "titleOfCreditor",
            type: "text",
            className: "col-4",
          },
          {
            title: "DATE",
            field: "dateSignedByCreditor",
            type: "date",
            className: "col-4",
          },
          {
            type: "content",
            content: (
              <p className="">
                The confidentiality of the information you have furnished will
                be preserved except where disclosure of this information is
                requires by applicable law. The form is to be transmitted
                directly to the lender and is not to be transmitted through the
                applicant or any other party.
              </p>
            ),
          },
        ],
      },
    ],
  },
];
export const brokerForm5 = [
  {
    field: "",
    arr: [
      {
        section: "Uniform Residential Loan Application",
        className: "col-12",
        arr: [
          {
            content: (
              <p>
                This application is designed to be completed by the applicant(s)
                with the Lender’s assistance. Applicants should complete this
                form as “Borrower” or “Co-Borrower,” as applicable. Co-Borrower
                information must also be provided (and the appropriate box
                checked) when
              </p>
            ),
            type: "content",
            className: "col-12",
          },
          {
            title:
              "the income or assets of a person other than the Borrower (including the Borrower’s spouse) will be used as a basis for loan qualification or",
            field: "checkbox1",
            type: "checkbox",
            className: "col-12",
          },
          {
            title:
              "the income or assets of the Borrower’s spouse or other person who has community property rights pursuant to state law will not be used as a basis for loan qualification, but his or her liabilities must be considered because the spouse or other person has community property rights pursuant to applicable law and Borrower resides in a community property state, the security property is located in a community property state, or the Borrower is relying on other property located in a community property state as a basis for repayment of the loan. ",
            field: "checkbox2",
            type: "checkbox",
            className: "col-12",
          },
          {
            content: (
              <p>
                {" "}
                If this is an application for joint credit, Borrower and
                Co-Borrower each agree that we intend to apply for joint credit
                (sign below):
              </p>
            ),
            type: "content",
            className: "col-12",
          },
          {
            title: "Borrower",
            field: "BorrowerSign",
            type: "text",
            className: "col-6",
          },
          {
            title: "Co-Borrower",
            field: "CoBorrowerSign",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "I. TYPE OF MORTGAGE AND TERMS OF LOAN",
        className: "col-12",
        arr: [],
      },
      {
        section: "",
        className: "col-6",
        arr: [
          {
            title: "Mortgage Applied for:",
            content: <p>Mortgage Applied for:</p>,
            type: "content",
          },
          {
            title: "VA",
            field: "vaLoan",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "FHA",
            field: "fhaLoan",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Conventional",
            field: "conventionalLoan",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "USDA/Rural Housing Service",
            field: "usdaRuralLoan",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Other (explain)",
            field: "otherLoanType",
            type: "checkbox",
            className: "col-4",
          },
        ],
      },
      {
        section: "",
        className: "col-6",
        arr: [
          {
            title: "Agency Case Number",
            field: "agencyCaseNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Lender Case Number",
            field: "lenderCaseNumber",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "Amount",
            field: "loanAmount",
            type: "number",
            className: "col-2",
          },
          {
            title: "Interest Rate",
            field: "interestRate",
            type: "text",
            className: "col-2",
          },
          {
            title: "No. of Months",
            field: "loanDurationMonths",
            type: "number",
            className: "col-2",
          },
          {
            title: "Fixed Rate",
            field: "fixedRate",
            type: "checkbox",
            className: "col-2",
          },
          {
            title: "GPM",
            field: "gpm",
            type: "checkbox",
            className: "col-2",
          },
          {
            title: "ARM (type)",
            field: "armType",
            type: "text",
            className: "col-1",
          },
          {
            title: "Other (explain)",
            field: "otherAmortizationType",
            type: "text",
            className: "col-1",
          },
        ],
      },
      {
        section: "II. Property Information and Purpose of Loan",
        className: "col-12",
        arr: [
          {
            title: "Subject Property Address (street, city, state & ZIP)",
            field: "subjectPropertyAddress",
            type: "text",
            className: "col-8",
          },
          {
            title: "No. of Units",
            field: "numberOfUnits",
            type: "number",
            className: "col-4",
          },
          {
            title: "Legal Description of Subject Property",
            field: "legalDescription",
            type: "textarea",
            className: "col-8",
          },
          {
            title: "Year Built",
            field: "yearBuilt",
            type: "text",
            className: "col-4",
          },
        ],
      },
      {
        section: "Purpose of Loan",
        className: "col-6",
        arr: [
          {
            title: "Purchase",
            field: "loanPurposePurchase",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Construction",
            field: "loanPurposeConstruction",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Refinance",
            field: "loanPurposeRefinance",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Construction-Permanent",
            field: "loanPurposeConstructionPermanent",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Other (explain)",
            field: "loanPurposeOther",
            type: "checkbox",
            className: "col-4",
          },
        ],
      },
      {
        section: "Property will be:",
        className: "col-6",
        arr: [
          {
            title: "Primary Residence",
            field: "propertyPrimaryResidence",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Secondary Residence",
            field: "propertySecondaryResidence",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Investment",
            field: "propertyInvestment",
            type: "checkbox",
            className: "col-4",
          },
        ],
      },
      {
        section:
          "Complete this line if construction or construction-permanent loan. ",
        className: "col-12",
        arr: [
          {
            title: "Year Lot Acquired",
            field: "yearLotAcquired",
            type: "number",
            className: "col-4",
          },
          {
            title: "Original Cost",
            field: "originalCost",
            type: "number",
            className: "col-4",
          },
          {
            title: "Amount Existing Liens",
            field: "amountExistingLiens",
            type: "number",
            className: "col-4",
          },
          {
            title: "Present Value of Lot",
            field: "presentValueOfLot",
            type: "number",
            className: "col-4",
          },
          {
            title: "Cost of Improvements",
            field: "costOfImprovements",
            type: "number",
            className: "col-4",
          },
          {
            title: "Total (a + b)",
            field: "totalCost",
            type: "number",
            className: "col-4",
          },
        ],
      },
      {
        section: "Complete this line if this is a refinance loan. ",
        className: "col-12",
        arr: [
          {
            title: "Year Acquired",
            field: "yearAcquired",
            type: "number",
            className: "col-3",
          },
          {
            title: "Original Cost",
            field: "refinanceoriginalCost",
            type: "number",
            className: "col-3",
          },
          {
            title: "Amount Existing Liens",
            field: "refinanceamountExistingLiens",
            type: "number",
            className: "col-3",
          },
          {
            title: "Purpose of Refinance",
            field: "purposeOfRefinance",
            type: "text",
            className: "col-3",
          },
          {
            title: "Describe Improvements",
            field: "describeImprovements",
            type: "text",
            className: "col-3",
          },
          {
            title: "Improvements Cost",
            field: "improvementsCost",
            type: "number",
            className: "col-3",
          },
          {
            title: "Improvements Made",
            field: "improvementsMade",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Improvements to be Made",
            field: "improvementsToBeMade",
            type: "checkbox",
            className: "col-3",
          },
        ],
      },
      {
        section: "",
        className: "col-8",
        arr: [
          {
            title: "Title will be held in what Name(s)",
            field: "titleHeldInNames",
            type: "text",
            className: "col-6",
          },
          {
            title: "Manner in which Title will be held",
            field: "titleHeldManner",
            type: "text",
            className: "col-6",
          },
          {
            title:
              "Source of Down Payment, Settlement Charges, and/or Subordinate Financing",
            field: "sourceOfDownPayment",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "Estate will be held in:",
        className: "col-4",
        arr: [
          {
            title: "Fee Simple",
            field: "estateHeldInFeeSimple",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Leasehold",
            field: "estateHeldInLeasehold",
            type: "checkbox",
            className: "col-6",
          },
        ],
      },
      {
        section: "III. BORROWER INFORMATION",
        className: "col-12",
        arr: [],
      },
      {
        section: "Borrower",
        className: "col-6",
        arr: [
          {
            title: "Borrower’s Name",
            field: "borrowersName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Social Security Number",
            field: "socialSecurityNumber",
            type: "text",
            className: "col-4",
          },
          {
            title: "Home Phone",
            field: "homePhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Date of Birth",
            field: "dateOfBirth",
            type: "date",
            className: "col-4",
          },
          {
            title: "Years of School",
            field: "yearsOfSchool",
            type: "number",
            className: "col-4",
          },
          {
            title: "Dependents (not listed by Co-Borrower) no.",
            field: "dependents",
            type: "text",
            className: "col-4",
          },
          {
            title: "Dependents Ages",
            field: "dependentsAges",
            type: "text",
            className: "col-4",
          },
          {
            title: "Married",
            field: "married",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Unmarried",
            field: "unmarried",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Separated  (single, divorced, widowed)",
            field: "separated",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Present Address",
            field: "presentAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Own",
            field: "housingStatusOwn",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Rent",
            field: "housingStatusRent",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Number of Years at Present Address",
            field: "numberOfYearsAtPresentAddress",
            type: "number",
            className: "col-4",
          },
          {
            title: "Mailing Address, if different from Present Address",
            field: "mailingAddress",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "Co-Borrower",
        className: "col-6",
        arr: [
          {
            title: "Co-Borrower’s Name (include Jr. or Sr. if applicable) ",
            field: "coborrowersName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Social Security Number",
            field: "coborrowersocialSecurityNumber",
            type: "text",
            className: "col-4",
          },
          {
            title: "Home Phone",
            field: "coborrowerhomePhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Date of Birth",
            field: "coborrowerdateOfBirth",
            type: "date",
            className: "col-4",
          },
          {
            title: "Years of School",
            field: "coborroweryearsOfSchool",
            type: "number",
            className: "col-4",
          },
          {
            title: "Dependents (not listed by Co-Borrower) no.",
            field: "coborrowerdependents",
            type: "text",
            className: "col-4",
          },
          {
            title: "Dependents Ages",
            field: "coborrowerdependentsAges",
            type: "text",
            className: "col-4",
          },
          {
            title: "Married",
            field: "coborrowermarried",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Unmarried",
            field: "coborrowerunmarried",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Separated  (single, divorced, widowed)",
            field: "coborrowerseparated",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Present Address",
            field: "coborrowerpresentAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Own",
            field: "coborrowerhousingStatusOwn",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Rent",
            field: "coborrowerhousingStatusRent",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Number of Years at Present Address",
            field: "coborrowernumberOfYearsAtPresentAddress",
            type: "number",
            className: "col-4",
          },
          {
            title: "Mailing Address, if different from Present Address",
            field: "coborrowermailingAddress",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section:
          "If residing at present address for less than two years, complete the following: ",
        className: "col-12",
        arr: [],
      },
      {
        section: "",
        className: "col-6",
        arr: [
          {
            title: "Former Address (street, city, state, ZIP)",
            field: "formerAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Own",
            field: "formerHousingStatusOwn",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Rent",
            field: "formerHousingStatusRent",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Number of Years at Former Address",
            field: "numberOfYearsAtFormerAddress",
            type: "number",
            className: "col-4",
          },
        ],
      },
      {
        section: "",
        className: "col-6",
        arr: [
          {
            title: "Former Address (street, city, state, ZIP)",
            field: "coborrowerformerAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Own",
            field: "coborrowerformerHousingStatusOwn",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Rent",
            field: "coborrowerformerHousingStatusRent",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Number of Years at Former Address",
            field: "coborrowernumberOfYearsAtFormerAddress",
            type: "number",
            className: "col-4",
          },
        ],
      },
      {
        section: "IV. EMPLOYMENT INFORMATION",
        className: "col-12",
        arr: [],
      },
      {
        section: "Borrower",
        className: "col-6",
        arr: [
          {
            title: "Years on Job",
            field: "borrowerYearsOnJob",
            type: "text",
            className: "col-12",
          },
          {
            title: "Employer Name & Address",
            field: "borrowerEmployerNameAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Self Employed",
            field: "borrowerSelfEmployed",
            type: "checkbox",
            className: "col-12",
          },
          {
            title: "Position/Title/Type of Business",
            field: "borrowerPositionTitleTypeOfBusiness",
            type: "text",
            className: "col-12",
          },
          {
            title: "Business Phone",
            field: "borrowerBusinessPhone",
            type: "phoneNumber",
            className: "col-12",
          },
        ],
      },
      {
        section: "Co-Borrower",
        className: "col-6",
        arr: [
          {
            title: "Years on Job",
            field: "coBorrowerYearsOnJob",
            type: "text",
            className: "col-12",
          },
          {
            title: "Employer Name & Address",
            field: "coBorrowerEmployerNameAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Self Employed",
            field: "coBorrowerSelfEmployed",
            type: "checkbox",
            className: "col-12",
          },
          {
            title: "Position/Title/Type of Business",
            field: "coBorrowerPositionTitleTypeOfBusiness",
            type: "text",
            className: "col-12",
          },
          {
            title: "Business Phone",
            field: "coBorrowerBusinessPhone",
            type: "phoneNumber",
            className: "col-12",
          },
        ],
      },
      {
        section: "IV. EMPLOYMENT INFORMATION (cont’d)",
        className: "col-12",
        arr: [],
      },
      {
        section: "Borrower",
        className: "col-6",
        arr: [
          {
            title: "Dates (from – to)",
            field: "borrowerEmploymentDates",
            type: "text",
            className: "col-12",
          },
          {
            title: "Name & Address of Employer",
            field: "borrowerEmployerNameAddressCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Self Employed",
            field: "borrowerSelfEmployedCont",
            type: "checkbox",
            className: "col-12",
          },
          {
            title: "Monthly Income",
            field: "borrowerMonthlyIncomeCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Position/Title/Type of Business",
            field: "borrowerPositionTitleTypeOfBusinessCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Business Phone",
            field: "borrowerBusinessPhoneCont",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            title: "Dates (from – to)",
            field: "borrowerEmploymentDates",
            type: "text",
            className: "col-12",
          },
          {
            title: "Name & Address of Employer",
            field: "borrowerEmployerNameAddressCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Self Employed",
            field: "borrowerSelfEmployedCont",
            type: "checkbox",
            className: "col-12",
          },
          {
            title: "Monthly Income",
            field: "borrowerMonthlyIncomeCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Position/Title/Type of Business",
            field: "borrowerPositionTitleTypeOfBusinessCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Business Phone",
            field: "borrowerBusinessPhoneCont",
            type: "phoneNumber",
            className: "col-12",
          },
        ],
      },
      {
        section: "Co-Borrower",
        className: "col-6",
        arr: [
          {
            title: "Dates (from – to)",
            field: "borrowerEmploymentDates",
            type: "text",
            className: "col-12",
          },
          {
            title: "Name & Address of Employer",
            field: "borrowerEmployerNameAddressCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Self Employed",
            field: "borrowerSelfEmployedCont",
            type: "checkbox",
            className: "col-12",
          },
          {
            title: "Monthly Income",
            field: "borrowerMonthlyIncomeCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Position/Title/Type of Business",
            field: "borrowerPositionTitleTypeOfBusinessCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Business Phone",
            field: "borrowerBusinessPhoneCont",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            title: "Dates (from – to)",
            field: "borrowerEmploymentDates",
            type: "text",
            className: "col-12",
          },
          {
            title: "Name & Address of Employer",
            field: "borrowerEmployerNameAddressCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Self Employed",
            field: "borrowerSelfEmployedCont",
            type: "checkbox",
            className: "col-12",
          },
          {
            title: "Monthly Income",
            field: "borrowerMonthlyIncomeCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Position/Title/Type of Business",
            field: "borrowerPositionTitleTypeOfBusinessCont",
            type: "text",
            className: "col-12",
          },
          {
            title: "Business Phone",
            field: "borrowerBusinessPhoneCont",
            type: "phoneNumber",
            className: "col-12",
          },
        ],
      },
      {
        section: "V. MONTHLY INCOME AND COMBINED HOUSING EXPENSE INFORMATION",
        className: "col-12",
        arr: [
          {
            type: "table",
            className: "col-6",
            title: "Gross Monthly Income",
            defaultData: [
              {
                label: "Base Empl. Income",
              },
              {
                label: "Overtime",
              },
              {
                label: "Bonuses",
              },
              {
                label: "Commissions",
              },
              {
                label: "Dividends/Interest",
              },
              {
                label: "Net Rental Income",
              },
              {
                label:
                  "Other (before completing, see the notice in 'describe other income,' below)",
              },
            ],
            columns: [
              { label: "Borrower", id: "borrower", type: "number" },
              { label: "Co-Borrower", id: "coBorrower", type: "number" },
            ],
            bottomTotal: true,
            rightTotal: true,
          },
          {
            type: "table",
            className: "col-6",
            title: "Combined Monthly Housing Expense",
            defaultData: [
              {
                label: "Rent",
              },
              {
                label: "First Mortgage (P&I)",
              },
              {
                label: "Other Financing (P&I)",
              },
              {
                label: "Hazard Insurance",
              },
              {
                label: "Real Estate Taxes",
              },
              {
                label: "Mortgage Insurance",
              },
              {
                label: "Homeowner Assn. Dues",
              },
              {
                label: "Other",
              },
            ],
            columns: [
              { label: "Present", id: "present", type: "number" },
              { label: "Proposed", id: "proposed", type: "number" },
            ],
            bottomTotal: true,
            rightTotal: true,
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                * Self Employed Borrower(s) may be required to provide
                additional documentation such as tax returns and financial
                statements.{" "}
              </p>
            ),
          },
          {
            type: "content",
            className: "col-4",
            content: <p>Describe Other Income</p>,
          },
          {
            type: "content",
            className: "col-8",
            content: (
              <p>
                Notice: Alimony, child support, or separate maintenance income
                need not be revealed if the Borrower (B) or Co-Borrower (C) does
                not choose to have it considered for repaying this loan.
              </p>
            ),
          },
          {
            type: "table",
            className: "col-12",
            title: "",
            defaultData: [
              {
                label: "",
              },
              {
                label: "",
              },
              {
                label: "",
              },
            ],
            columns: [
              { label: "B/C", id: "b/c", type: "text" },
              { label: "", id: "borrower", type: "text" },
              { label: "Monthly Amount", id: "monthlyAmount", type: "number" },
            ],
            hasTotal: false,
          },
        ],
      },
      {
        section: "VI. ASSETS AND LIABILITIES",
        className: "col-6",
        arr: [
          {
            type: "content",
            content: (
              <p>
                This Statement and any applicable supporting schedules may be
                completed jointly by both married and unmarried Co-Borrowers if
                their assets and liabilities are sufficiently joined so that the
                Statement can be meaningfully and fairly presented on a combined
                basis; otherwise, separate Statements and Schedules are
                required. If the Co-Borrower section was completed about a
                non-applicant spouse or other person, this Statement and
                supporting schedules must be completed about that spouse or
                other person also.
              </p>
            ),
          },
          {
            title: "Completed",
            field: "assetsLiabilities_Completed",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Jointly",
            field: "assetsLiabilities_Jointly",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Not Jointly",
            field: "assetsLiabilities_NotJointly",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Assets - Description",
            field: "assets_description",
            type: "text",
            className: "col-6",
          },
          {
            title: "Assets - Cash deposit toward purchase held by",
            field: "assetsLiabilities_CashDeposit",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            content: <p>List checking and savings accounts below</p>,
          },
          {
            title: "Name and address of Bank, S&L, or Credit Union",
            field: "assetsLiabilities_BankNameAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Acct. no.",
            field: "assetsLiabilities_AccountNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_Amount",
            type: "text",
            className: "col-6",
          },
          {
            title: "Name and address of Bank, S&L, or Credit Union1",
            field: "assetsLiabilities_BankNameAddress1",
            type: "text",
            className: "col-12",
          },
          {
            title: "Acct. no.",
            field: "assetsLiabilities_AccountNumber1",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_Amount1",
            type: "text",
            className: "col-6",
          },
          {
            title: "Name and address of Bank, S&L, or Credit Union2",
            field: "assetsLiabilities_BankNameAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Acct. no.",
            field: "assetsLiabilities_AccountNumber2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_Amount2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Name and address of Bank, S&L, or Credit Union3",
            field: "assetsLiabilities_BankNameAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Acct. no.",
            field: "assetsLiabilities_AccountNumber3",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_Amount3",
            type: "text",
            className: "col-6",
          },
          {
            title: "",
            field: "assetsLiabilities_",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_Amount3",
            type: "text",
            className: "col-6",
          },
          {
            title: "Stocks & Bonds (Company name/ number & description)",
            field: "assetsLiabilities_Stocks",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_AmountStocks",
            type: "text",
            className: "col-6",
          },
          {
            title: "Life insurance net cash value Face amount",
            field: "assetsLiabilities_lifeInsurance",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_AmountlifeInsurance",
            type: "text",
            className: "col-6",
          },
          {
            title: "Subtotal Liquid Assets",
            field: "assetsLiabilities_subtotal",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_subtotalAmount3",
            type: "text",
            className: "col-6",
          },
          {
            title:
              "Real estate owned (enter market value from schedule of real estate owned) $",
            field: "assetsLiabilities_realEstateAmount",
            type: "text",
            className: "col-12",
          },
          {
            title: "Vested interest in retirement fund ",
            field: "assetsLiabilities_vestedInterest",
            type: "text",
            className: "col-6",
          },
          {
            title:
              "Net worth of business(es) owned (attach financial statement)",
            field: "assetsLiabilities_AmountNetWorthofBusiness",
            type: "text",
            className: "col-6",
          },
          {
            title: "Automobiles owned (make $ and year)",
            field: "assetsLiabilities_AutomobilesOwned",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_AmountAutomobilesOwned",
            type: "text",
            className: "col-6",
          },
          {
            title: "Other Assests (itemize)",
            field: "assetsLiabilities_otherAssets",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_AmountOtherAssets",
            type: "text",
            className: "col-6",
          },
          {
            title: "Total Assets a.",
            field: "assetsLiabilities_AmountTotalAssets",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "VI. cont'd",
        className: "col-6",
        arr: [
          {
            type: "content",
            content: (
              <p>
                Liabilities and Pledged Assets. List the creditor’s name,
                address, and account number for all outstanding debts, including
                automobile loans, revolving charge accounts, real estate loans,
                alimony, child support, stock pledges, etc. Use continuation
                sheet, if necessary. Indicate by (*) those liabilities, which
                will be satisfied upon sale of real estate owned or upon
                refinancing of the subject property.
              </p>
            ),
          },
          {
            type: "table",
            className: "col-12",
            title: "",
            defaultData: [
              {
                label: "",
              },
              {
                label: "",
              },
              {
                label: "",
              },
              {
                label: "",
              },
              {
                label: "",
              },
              {
                label: "",
              },
            ],
            columns: [
              {
                label: "Liabilities - Name and address of Company",
                id: "nameAndAddress",
                type: "text",
              },
              { label: "Liabilities - Acct. no.", id: "accNo", type: "text" },
              {
                label:
                  "Monthly Payment & Months Left to Pay ($ Payment/Months)",
                id: "monthlyPayment",
                type: "text",
              },
              { label: "Unpaid Balance", id: "unpaidBalance", type: "text" },
            ],
            bottomTotal: false,
            rightTotal: false,
          },
          {
            title:
              "Alimony/Child Support/Separate Maintenance Payments Owed to",
            field: "assetsLiabilities_alimony",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_AmountAlimony",
            type: "text",
            className: "col-6",
          },
          {
            title: "Job-Related Expense (child care, union dues, etc.)",
            field: "assetsLiabilities_jobRelatedExpense",
            type: "text",
            className: "col-6",
          },
          {
            title: "Amount.",
            field: "assetsLiabilities_JobExp",
            type: "text",
            className: "col-6",
          },
          {
            title: "Total Monthly Payments",
            field: "assetsLiabilities_TotalMonthlyPayments",
            type: "text",
            className: "col-6",
          },
          {
            title: "Net Worth (a minus b)",
            field: "assetsLiabilities_NetWorth",
            type: "text",
            className: "col-6",
          },
          {
            title: "Total Liabilities b.",
            field: "assetsLiabilities_totalLiabilities",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Complete this line if this is a refinance loan. ",
        className: "col-12",
        arr: [
          {
            type: "content",
            content: (
              <p>
                Schedule of Real Estate Owned (If additional properties are
                owned, use continuation sheet.)
              </p>
            ),
          },
          {
            type: "table",
            className: "col-12",
            title: "",
            defaultData: [
              {
                label: "",
              },
              {
                label: "",
              },
              {
                label: "",
              },
            ],
            columns: [
              {
                label:
                  "Property Address (enter S if sold, PS if pending sale or R if rental being held for income)",
                id: "propteryAddress",
                type: "text",
              },
              {
                label: "Type of Property",
                id: "typeOfProperty",
                type: "number",
              },
              {
                label: "Present Market Value",
                id: "presentMarketValue",
                type: "number",
              },
              {
                label: "Amount of Mortgages & Liens",
                id: "AmountofMortgages&Liens",
                type: "number",
              },
              {
                label: "Gross Rental Income",
                id: "GrossRentalIncome",
                type: "number",
              },
              {
                label: "Mortgage Payments",
                id: "MortgagePayments",
                type: "number",
              },
              {
                label: "Insurance, Maintenance, Taxes & Misc.",
                id: "Insurance,Maintenance,Taxes&Misc.",
                type: "number",
              },
              {
                label: "Net Rental Income",
                id: "NetRentalIncome",
                type: "number",
              },
            ],
            hasTotal: true,
            bottomTotal: true,
          },
          {
            type: "content",
            content: (
              <p>
                List any additional names under which credit has previously been
                received and indicate appropriate creditor name(s) and account
                number(s):
              </p>
            ),
          },
          {
            type: "table",
            className: "col-12",
            title: "",
            defaultData: [
              {
                label: "",
              },
              {
                label: "",
              },
            ],
            columns: [
              {
                label: "Alternate Name",
                id: "altName",
                type: "text",
              },
              {
                label: "Creditor Name",
                id: "creditorName",
                type: "text",
              },
              {
                label: "Account Name",
                id: "accountName",
                type: "text",
              },
            ],
          },
        ],
      },
      {
        section: "VII. DETAILS OF TRANSACTION",
        className: "col-6",
        arr: [
          {
            type: "table",
            className: "col-12",
            title: "ASSETS",
            defaultData: [
              {
                label: "a. Purchase price",
                value: "",
                type: "number",
              },
              {
                label: "b. Alterations, improvements, repairs",
                value: "",
                type: "number",
              },
              {
                label: "C. Land (if acquired separately)",
                value: "",
                type: "number",
              },
              {
                label: "d. Refinance (incl. debts to be paid off)",
                value: "",
                type: "number",
              },
              {
                label: "e. Estimated prepaid items",
                value: "",
                type: "number",
              },
              {
                label: "f. Estimated closing costs",
                value: "",
                type: "number",
              },
              {
                label: "g. PMI, MIP, Funding Fee",
                value: "",
                type: "number",
              },
              {
                label: "h. Discount (if Borrower will pay)",
                value: "",
                type: "number",
              },
              {
                label: "i. Total costs (add items a through h)",
                value: "",
                type: "number",
              },
              {
                label: "j. Subordinate financing",
                value: "",
                type: "number",
              },
              {
                label: "k. Borrower's closing costs paid by Seller",
                value: "",
                type: "number",
              },
              {
                label: "l. Other Credits (explain)",
                value: "",
                type: "number",
              },
              {
                label:
                  "m. Loan amount (exclude PMI, MIP, Funding Fee financed)",
                value: "",
                type: "number",
              },
              {
                label: "n. PMI, MIP, Funding Fee financed",
                value: "",
                type: "number",
              },
              {
                label: "o. Loan amount (add m & n)",
                value: "",
                type: "number",
              },
              {
                label: "p. Cash from/to Borrower (subtract j, k, l & o from i)",
                value: "",
                type: "number",
              },
            ],
            columns: [{ label: "", id: "borrower", type: "number" }],
            bottomTotal: true,
            rightTotal: false,
            typeOntheBasisOfDefaultData: true,
          },
        ],
      },
      {
        section: "VIII. DECLARATIONS",
        className: "col-6",
        arr: [
          {
            type: "content",
            content: (
              <p>
                If you answer “Yes” to any question a through i, please use
                continuation sheet for explanation.
              </p>
            ),
          },
          {
            type: "content",
            content: <LoanForm />,
          },
          {
            title:
              "(1) What type of property did you own—principal residence (PR), second home (SH), or investment property (IP)?",
            field: "declaration_typeOfProperty",
            type: "text",
            className: "col-12",
          },
          {
            title:
              "(2) How did you hold title to the home— by yourself (S), jointly with your spouse or jointly with another person (O)?",
            field: "declaration_titleToTheHome",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "IX. ACKNOWLEDGEMENT AND AGREEMENT",
        className: "col-12",
        arr: [
          {
            type: "content",
            content: (
              <p>
                Each of the undersigned specifically represents to Lender and to
                Lender's actual or potential agents, brokers, processors,
                attorneys, insurers, servicers, successors and assigns and
                agrees and acknowledges that: (1) the information provided in
                this application is true and correct as of the date set forth
                opposite my signature and that any intentional or negligent
                misrepresentation of this information contained in this
                application may result in civil liability, including monetary
                damages, to any person who may suffer any loss due to reliance
                upon any misrepresentation that I have made on this application,
                and/or in criminal penalties including, but not limited to, fine
                or imprisonment or both under the provisions of Title 18, United
                States Code, Sec. 1001, et seq.; (2) the loan requested pursuant
                to this application (the "Loan") will be secured by a mortgage
                or deed of trust on the property described in this application;
                (3) the property will not be used for any illegal or prohibited
                purpose or use; (4) all statements made in this application are
                made for the purpose of obtaining a residential mortgage loan;
                (5) the property will be occupied as indicated in this
                application; (6) the Lender, its servicers, successors or
                assigns may retain the original and/or an electronic record of
                this application, whether or not the Loan is approved; (7) the
                Lender and its agents, brokers, insurers, servicers, successors,
                and assigns may continuously rely on the information contained
                in the application, and I am obligated to amend and/or
                supplement the information provided in this application if any
                of the material facts that I have represented herein should
                change prior to closing of the Loan; (8) in the event that my
                payments on the Loan become delinquent, the Lender, its
                servicers, successors or assigns may, in addition to any other
                rights and remedies that it may have relating to such
                delinquency, report my name and account information to one or
                more consumer reporting agencies; (9) ownership of the Loan
                and/or administration of the Loan account may be transferred
                with such notice as may be required by law; (10) neither Lender
                nor its agents, brokers, insurers, servicers, successors or
                assigns has made any representation or warranty, express or
                implied, to me regarding the property or the condition or value
                of the property; and (11) my transmission of this application as
                an "electronic record" containing my "electronic signature," as
                those terms are defined in applicable federal and/or state laws
                (excluding audio and video recordings), or my facsimile
                transmission of this application containing a facsimile of my
                signature, shall be as effective, enforceable and valid as if a
                paper version of this application were delivered containing my
                original written signature. Acknowledgement. Each of the
                undersigned hereby acknowledges that any owner of the Loan, its
                servicers, successors and assigns, may verify or reverify any
                information contained in this application or obtain any
                information or data relating to the Loan, for any legitimate
                business purpose through any source, including a source named in
                this application or a consumer reporting agency.
              </p>
            ),
          },
          {
            title: "Borrower's Signature",
            field: "achknowledgement_borrowersSignature",
            type: "text",
            className: "col-3",
          },
          {
            title: "Date",
            field: "achknowledgement_date1",
            type: "date",
            className: "col-3",
          },
          {
            title: "Co-Borrower's Signature",
            field: "achknowledgement_coborrowersSignature",
            type: "text",
            className: "col-3",
          },
          {
            title: "Date",
            field: "achknowledgement_date2",
            type: "text",
            className: "col-3",
          },
        ],
      },
      {
        section: "X. INFORMATION FOR GOVERNMENT MONITORING PURPOSES",
        className: "col-12",
        arr: [
          {
            type: "content",
            content: (
              <p>
                The following information is requested by the Federal Government
                for certain types of loans related to a dwelling in order to
                monitor the lender's compliance with equal credit opportunity,
                fair housing and home mortgage disclosure laws. You are not
                required to furnish this information, but are encouraged to do
                so. The law provides that a lender may not discriminate either
                on the basis of this information, or on whether you choose to
                furnish it. If you furnish the information, please provide both
                ethnicity and race. For race, you may check more than one
                designation. If you do not furnish ethnicity, race, or sex,
                under Federal regulations, this lender is required to note the
                information on the basis of visual observation and surname if
                you have made this application in person. If you do not wish to
                furnish the information, please check the box below. (Lender
                must review the above material to assure that the disclosures
                satisfy all requirements to which the lender is subject under
                applicable state law for the particular type of loan applied
                for.)
              </p>
            ),
          },
        ],
      },
      {
        section: "",
        className: "col-6",
        arr: [
          {
            title: "Borrower - I do not wish to furnish this information",
            field: "govtMonitoring_borrowerInfo",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Ethnicity",
            field: "govtMonitoring_ethnicity",
            type: "radio",
            options: [
              { title: "Hispanic or Latino", value: "HispanicorLatino" },
              { title: "Not Hispanic or Latino", value: "NotHispanicorLatino" },
            ],
          },
          {
            title: "",
            field: "govtMonitoring_borrowerRace",
            type: "radio",
            options: [
              {
                title: "American Indian or Alaska Native",
                value: "AmericanIndianorAlaskaNative",
              },
              { title: "Asian", value: "asian" },
              {
                title: "Black or African American",
                value: "BlackorAfricanAmerican",
              },
              {
                title: "Native Hawaiian or Other Pacific Islander",
                value: "NativeHawaiianorOtherPacificIslander",
              },
              { title: "White", value: "White" },
            ],
          },
          {
            title: "Sex",
            field: "govtMonitoring_borrowerSex",
            type: "radio",
            options: [
              { title: "Male", value: "male" },
              { title: "Female", value: "female" },
            ],
          },
          {
            type: "content",
            content: <p>To be Completed by Loan Originator:</p>,
          },
          {
            title: "This information was provided: ",
            field: "govtMonitoring_infoBy",
            type: "radio",
            options: [
              {
                title: "In a face-to-face interview",
                value: "Inaface-to-faceinterview",
              },
              {
                title: "In a telephone interview",
                value: "Inatelephoneinterview",
              },
              {
                title: "By the applicant and submitted by fax or mail",
                value: "Bytheapplicantandsubmittedbyfaxormail",
              },
              {
                title:
                  "By the applicant and submitted via e-mail or the Internet",
                value: "Bytheapplicantandsubmittedviae-mailortheInternet",
              },
            ],
          },
        ],
      },
      {
        section: "",
        className: "col-6",
        arr: [
          {
            title: "Co-Borrower - I do not wish to furnish this information",
            field: "govtMonitoring_coBorrowerInfo",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Ethnicity",
            field: "govtMonitoring_coEthnicity",
            type: "radio",
            options: [
              { title: "Hispanic or Latino", value: "HispanicorLatino" },
              { title: "Not Hispanic or Latino", value: "NotHispanicorLatino" },
            ],
          },
          {
            title: "",
            field: "govtMonitoring_coBorrowerRace",
            type: "radio",
            options: [
              {
                title: "American Indian or Alaska Native",
                value: "AmericanIndianorAlaskaNative",
              },
              { title: "Asian", value: "asian" },
              {
                title: "Black or African American",
                value: "BlackorAfricanAmerican",
              },
              {
                title: "Native Hawaiian or Other Pacific Islander",
                value: "NativeHawaiianorOtherPacificIslander",
              },
              { title: "White", value: "White" },
            ],
          },
          {
            title: "Sex",
            field: "govtMonitoring_coBorrowerSex",
            type: "radio",
            options: [
              { title: "Male", value: "male" },
              { title: "Female", value: "female" },
            ],
          },
        ],
      },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "Loan Originator's Signature",
            field: "govtMonitoring_originatorsSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Date",
            field: "govtMonitoring_originatorsDate",
            type: "date",
            className: "col-6",
          },
          {
            title: "Loan Originator's Name (print or type)",
            field: "govtMonitoring_originatorsName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Originator Identifier",
            field: "govtMonitoring_originatorsIdentifier",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Originator's Phone Number (including area code)",
            field: "govtMonitoring_originatorsNumber",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Loan Originator's Name (print or type)",
            field: "govtMonitoring_originatorsName1",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Originator Identifier",
            field: "govtMonitoring_originatorsIdentifier1",
            type: "text",
            className: "col-6",
          },
          {
            title: "Loan Originator's Phone Number (including area code)",
            field: "govtMonitoring_originatorsNumber1",
            type: "phoneNumber",
            className: "col-6",
          },
        ],
      },
      {
        section: "CONTINUATION SHEET/RESIDENTIAL LOAN APPLICATION",
        className: "col-12",
        arr: [
          {
            type: "content",
            content: (
              <p>
                Use this continuation sheet if you need more space to complete
                the Residential Loan Application. Mark B for Borrower or C for
                Co-Borrower.
              </p>
            ),
          },
          {
            title: "Borrower",
            field: "continuation_borrower",
            type: "text",
            className: "col-6",
          },
          {
            title: "Agency Case Number",
            field: "continuation_caseNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower",
            field: "continuation_coBorrower",
            type: "text",
            className: "col-6",
          },
          {
            title: "Lender Case Number",
            field: "continuation_lenderCaseNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Additional Information",
            field: "continuation_additionalInformation",
            type: "textarea",
            className: "col-12",
          },
          {
            type: "content",
            content: (
              <p>
                I/We fully understand that it is a Federal crime punishable by
                fine or imprisonment, or both, to knowingly make any false
                statements concerning any of the above facts as applicable under
                the provisions of Title 18, United States Code, Section 1001, et
                seq.
              </p>
            ),
          },
          {
            title: "Borrower's Signature",
            field: "continuation_borrowersSignature",
            type: "text",
            className: "col-3",
          },
          {
            title: "Date",
            field: "continuation_date1",
            type: "date",
            className: "col-3",
          },
          {
            title: "Co-Borrower's Signature",
            field: "continuation_coborrowersSignature",
            type: "text",
            className: "col-3",
          },
          {
            title: "Date",
            field: "continuation_date2",
            type: "text",
            className: "col-3",
          },
        ],
      },
    ],
  },
];
export const brokerForm6 = [
  {
    field: "",
    arr: [
      {
        section: "",
        className: "col-12",
        arr: [
          {
            type: "content",
            content: (
              <>
                <h4 className="mt-5 text-center">
                  STEWART TITLE OF CALIFORNIA, INC. <br />
                  STATEMENT OF INFORMATION{" "}
                </h4>
                <p className="text-center">
                  <b>
                    CONFIDENTIAL INFORMATION STATEMENT TO BE USED IN CONNECTION
                    WITH ORDER NO:
                  </b>
                </p>
                <p className="text-center">
                  COMPLETION OF THIS FORM WILL EXPEDITE YOUR ORDER AND WILL HELP
                  PROTECT YOU.{" "}
                </p>
              </>
            ),
          },
        ],
      },
      {
        section: "THE STREET ADDRESS of the property in this transaction is:",
        className: "col-12",
        arr: [
          {
            type: "content",
            content: <p>IF NONE LEAVE BLANK</p>,
            className: "col-12",
          },
          {
            title: "ADDRESS",
            field: "HUSBANDADDRESS",
            type: "text",
            className: "col-6",
          },
          {
            title: "CITY",
            field: "CITY",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            type: "content",
            content: <p>IMPROVEMENTS:</p>,
            className: "col-3",
          },
          {
            title: "SINGLE RESIDENCE",
            field: "SINGLERESIDENCE",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Multiple Residence",
            field: "multipleResidence",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Commercial",
            field: "commercial",
            type: "checkbox",
            className: "col-3",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            type: "content",
            content: <p>Occupied By:</p>,
            className: "col-3",
          },
          {
            title: "Owner",
            field: "owner",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Lessee",
            field: "lessee",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Tenants",
            field: "tenants",
            type: "checkbox",
            className: "col-3",
          },
        ],
      },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "Any Portion of New Loan Funds to Be Used for Construction",
            field: "useLoanForConstruction",
            type: "radio",
            className: "col-6",
            options: [
              { title: "Yes", value: "yes" },
              { title: "No", value: "no" },
            ],
          },
        ],
      },
      {
        section: "NAME",
        className: "col-6",
        arr: [
          {
            title: "First Name",
            field: "firstName",
            type: "text",
            className: "col-4",
          },
          {
            title: "Middle Name",
            field: "middleName",
            type: "text",
            className: "col-4",
          },
          {
            title: "Last Name",
            field: "lastName",
            type: "text",
            className: "col-4",
          },
          {
            title: "Birthplace",
            field: "birthplace",
            type: "text",
            className: "col-6",
          },
          {
            title: "Birth Date",
            field: "birthDate",
            type: "date",
            className: "col-6",
          },
          {
            title: "Lived in California Since",
            field: "livedInCaliforniaSince",
            type: "text",
            className: "col-6",
          },
          {
            title: "Social Security Number",
            field: "socialSecurityNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Driver's License Number",
            field: "driversLicenseNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Wife's Maiden Name",
            field: "wivesMaidenName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Marriage Date",
            field: "marriageDate",
            type: "date",
            className: "col-12",
          },
        ],
      },
      {
        section: "SPOUSES NAME",
        className: "col-6",
        arr: [
          {
            title: "First Name",
            field: "spousesfirstName",
            type: "text",
            className: "col-4",
          },
          {
            title: "Middle Name",
            field: "spousesmiddleName",
            type: "text",
            className: "col-4",
          },
          {
            title: "Last Name",
            field: "spouseslastName",
            type: "text",
            className: "col-4",
          },
          {
            title: "Birthplace",
            field: "spousesbirthplace",
            type: "text",
            className: "col-6",
          },
          {
            title: "Birth Date",
            field: "spousesbirthDate",
            type: "date",
            className: "col-6",
          },
          {
            title: "Lived in California Since",
            field: "spouseslivedInCaliforniaSince",
            type: "text",
            className: "col-6",
          },
          {
            title: "Social Security Number",
            field: "spousessocialSecurityNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Driver's License Number",
            field: "spousesdriversLicenseNumber",
            type: "text",
            className: "col-12",
          },

          {
            title: "AT",
            field: "spousesAT",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "RESIDENCE(S) FOR LAST 10 YEARS",
        className: "col-12",
        arr: [
          {
            title: "NUMBER AND STREET",
            field: "NUMBERANDSTREET",
            type: "text",
            className: "col-3",
          },
          {
            title: "CITY",
            field: "CITY",
            type: "text",
            className: "col-3",
          },
          {
            title: "FROM",
            field: "FROM",
            type: "text",
            className: "col-3",
          },
          {
            title: "TO",
            field: "TO",
            type: "text",
            className: "col-3",
          },

          {
            title: "NUMBER AND STREET",
            field: "NUMBERANDSTREET1",
            type: "text",
            className: "col-3",
          },
          {
            title: "CITY",
            field: "CITY1",
            type: "text",
            className: "col-3",
          },
          {
            title: "FROM",
            field: "FROM1",
            type: "text",
            className: "col-3",
          },
          {
            title: "TO",
            field: "TO1",
            type: "text",
            className: "col-3",
          },

          {
            title: "NUMBER AND STREET",
            field: "NUMBERANDSTREET2",
            type: "text",
            className: "col-3",
          },
          {
            title: "CITY",
            field: "CITY2",
            type: "text",
            className: "col-3",
          },
          {
            title: "FROM",
            field: "FROM2",
            type: "text",
            className: "col-3",
          },
          {
            title: "TO",
            field: "TO2",
            type: "text",
            className: "col-3",
          },

          {
            title: "NUMBER AND STREET",
            field: "NUMBERANDSTREET3",
            type: "text",
            className: "col-3",
          },
          {
            title: "CITY",
            field: "CITY3",
            type: "text",
            className: "col-3",
          },
          {
            title: "FROM",
            field: "FROM3",
            type: "text",
            className: "col-3",
          },
          {
            title: "TO",
            field: "TO3",
            type: "text",
            className: "col-3",
          },
        ],
      },
      {
        section: "OCCUPATION(S) FOR LAST 10 YEARS",
        className: "col-12",
      },
      {
        section: "HUSBAND",
        arr: [
          {
            title: "PRESENT OCCUPATION",
            field: "HUSBANDPRESENTOCCUPATION",
            type: "text",
            className: "col-3",
          },
          {
            title: "FIRM NAME",
            field: "HUSBANDFIRMNAME",
            type: "text",
            className: "col-3",
          },
          {
            title: "ADDRESS",
            field: "HUSBANDADDRESS",
            type: "text",
            className: "col-3",
          },
          {
            title: "NO. OF YEARS",
            field: "HUSBANDNOOFYEARS",
            type: "text",
            className: "col-3",
          },

          {
            title: "PRESENT OCCUPATION",
            field: "HUSBANDPRESENTOCCUPATION1",
            type: "text",
            className: "col-3",
          },
          {
            title: "FIRM NAME",
            field: "HUSBANDFIRMNAME1",
            type: "text",
            className: "col-3",
          },
          {
            title: "ADDRESS",
            field: "HUSBANDADDRESS1",
            type: "text",
            className: "col-3",
          },
          {
            title: "NO. OF YEARS",
            field: "HUSBANDNOOFYEARS1",
            type: "text",
            className: "col-3",
          },

          {
            title: "PRESENT OCCUPATION",
            field: "HUSBANDPRESENTOCCUPATION2",
            type: "text",
            className: "col-3",
          },
          {
            title: "FIRM NAME",
            field: "HUSBANDFIRMNAME2",
            type: "text",
            className: "col-3",
          },
          {
            title: "ADDRESS",
            field: "HUSBANDADDRESS2",
            type: "text",
            className: "col-3",
          },
          {
            title: "NO. OF YEARS",
            field: "HUSBANDNOOFYEARS2",
            type: "text",
            className: "col-3",
          },
        ],
      },

      {
        section: "WIFE",
        arr: [
          {
            title: "PRESENT OCCUPATION",
            field: "WIFEPRESENTOCCUPATION",
            type: "text",
            className: "col-3",
          },
          {
            title: "FIRM NAME",
            field: "WIFEFIRMNAME",
            type: "text",
            className: "col-3",
          },
          {
            title: "ADDRESS",
            field: "WIFEADDRESS",
            type: "text",
            className: "col-3",
          },
          {
            title: "NO. OF YEARS",
            field: "WIFENOOFYEARS",
            type: "text",
            className: "col-3",
          },

          {
            title: "PRESENT OCCUPATION",
            field: "WIFEPRESENTOCCUPATION1",
            type: "text",
            className: "col-3",
          },
          {
            title: "FIRM NAME",
            field: "WIFEFIRMNAME1",
            type: "text",
            className: "col-3",
          },
          {
            title: "ADDRESS",
            field: "WIFEADDRESS1",
            type: "text",
            className: "col-3",
          },
          {
            title: "NO. OF YEARS",
            field: "WIFENOOFYEARS1",
            type: "text",
            className: "col-3",
          },

          {
            title: "PRESENT OCCUPATION",
            field: "WIFEPRESENTOCCUPATION2",
            type: "text",
            className: "col-3",
          },
          {
            title: "FIRM NAME",
            field: "WIFEFIRMNAME2",
            type: "text",
            className: "col-3",
          },
          {
            title: "ADDRESS",
            field: "WIFEADDRESS2",
            type: "text",
            className: "col-3",
          },
          {
            title: "NO. OF YEARS",
            field: "WIFENOOFYEARS2",
            type: "text",
            className: "col-3",
          },
        ],
      },
      {
        section: "FORMER MARRIAGES:",
        className: "col-12",
        arr: [
          {
            title: "IF NO FORMER MARRIAGES, WRITE 'NONE'",
            field: "FORMERMARRIAGES",
            type: "text",
            className: "col-12",
          },
          {
            title: "NAME OF FORMER SPOUSE",
            field: "FORMERSPOUSE",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            content: "IF DECEASED:",
            className: "col-4",
          },
          {
            title: "DATE",
            field: "DECEASEDDATE",
            type: "date",
            className: "col-4",
          },
          {
            title: "WHERE",
            field: "DECEASEDWHERE",
            type: "text",
            className: "col-4",
          },
        ],
      },
      {
        section: "CURRENT LOAN ON PROPERTY",
        className: "col-12",
        arr: [
          {
            title: "PAYMENTS ARE BEING MADE TO:",
            field: "PAYMENTSAREBEINGMADETO",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "HOMEOWNERS ASSOCIATION",
        arr: [
          {
            title: "HOMEOWNERS ASSOCIATION",
            field: "HOMEOWNERSASSOCIATION",
            type: "text",
            className: "col-6",
          },
          {
            title: "NUMBER ( )",
            field: "HOMEOWNERSASSOCIATIONNUMBER",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Contact Information",
        arr: [
          {
            title: "Home Phone",
            field: "homePhone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Business Phone",
            field: "businessPhone",
            type: "phoneNumber",
            className: "col-6",
          },
        ],
      },
      {
        section: "Signature",
        arr: [
          {
            title: "Date",
            field: "signatureDate",
            type: "date",
            className: "col-6",
          },
          {
            title: "Signature",
            field: "signature",
            type: "text",
            className: "col-6",
          },
        ],
      },
    ],
  },
];
export const brokerForm7 = [
  {
    field: "Borrower Signature Authorization",
    arr: [
      {
        section: "",
        arr: [
          {
            content: (
              <>
                <b>Privacy Act Notice:</b>This information is to be used by the
                agency collecting it or its assignees in determining whether you
                qualify as a prospective mortgagor under its program. It will
                not be disclosed outside the agency except as required and
                permitted by law. You do not have to provide this information,
                but if you do not your application for approval as a prospective
                mortgagor or borrower may be delayed or rejected. The
                information requested in this form is authorized by Title 38,
                USC, Chapter 37 (if VA); by 12 USC, Section 1701 et. seq. (if
                HUD/FHA); by 42 USC, Section 1452b (if HUD/CPD); and Title 42
                USC, 1471 et. seq., or 7 USC, 1921 et. seq. (if USDA/FmHA).
              </>
            ),
            type: "content",
            className: "col-12",
          },
        ],
      },
      {
        section: "Part I - General Information",
        arr: [
          {
            title: "Borrower",
            field: "borrower",
            type: "text",
            className: "col-6",
          },
          {
            title: "Name and address of Lender/Broker",
            field: "lenderBrokerNameAddress",
            type: "text",
            className: "col-6",
          },
          {
            title: "Date",
            field: "date",
            type: "date",
            className: "col-3",
          },
          {
            title: "Loan Number",
            field: "loanNumber",
            type: "text",
            className: "col-3",
          },
        ],
      },
      {
        section: "Part II - Borrower Authorization",
        arr: [
          {
            content: (
              <>
                <p>
                  I hereby authorize the Lender/Broker to verify my past and
                  present employment earnings records, bank accounts, stock
                  holdings, and any other asset balances that are needed to
                  process my mortgage loan application. I further authorize the
                  Lender/Broker to order a consumer credit report and verify
                  other credit information, including past and present mortgage
                  and landlord references. It is understood that a copy of this
                  form will also serve as authorization.
                </p>
                <p>
                  The information the Lender/Broker obtains is only to be used
                  in the processing of my application for a mortgage loan.
                </p>
              </>
            ),
            type: "content",
          },
          {
            title: "Borrower",
            field: "borrowerSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Date",
            field: "signatureDate",
            type: "date",
            className: "col-6",
          },
        ],
      },
    ],
  },
];
export const brokerForm8 = [
  {
    field: "general",
    arr: [
      {
        section: "Lender Information (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 2 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested2",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 3 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested3",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 4 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested4",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "Lender Information - 5 (per the Note)",
        arr: [
          {
            title: "Lender Status",
            field: "loanInformation_PrepaymentPenalty",
            type: "radio",
            className: "col-9",
            options: [
              { title: "Existing Lender", value: "yes" },
              { title: "New Lender", value: "no" },
            ],
          },
          {
            title: "Existing SLS Lender Account #",
            field: "brokerContactInfo_Address",
            type: "text",
            className: "col-3",
          },
          {
            title: "Lender Name",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-9",
          },
          {
            title: "Amount Invested",
            field: "amountInvested5",
            type: "text",
            className: "col-3",
          },
          {
            title: "Vesting",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mailing Address",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Home Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Work Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },          
          {
            title: "Cell Phone",
            field: "brokerContactInfo_CellPhone",
            type: "phoneNumber",
            className: "col-4",
          },
          {
            title: "Email",
            field: "loanInformation_InterestRate",
            type: "email",
            className: "col-6",
          },
          {
            title: "SSN / Tax ID",
            field: "loanInformation_InterestRate",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            content: (
              <p className="text-center">
                7525 Topanga Canyon Blvd. Canoga Park, CA 91303 ◼ 8920 W. Tropicana Ave. Ste. 103 Las Vegas, <br></br> NV 89147
                Customer Service: Ph: 818-483-0027 ◼ Fax: 818-876-0337 ◼ info@superiorloanservicing.com<br></br>
                DRE No.: 01878271 ◼ NMLS No.: 235487<br></br>
                www.superiorloanservicing.com 
              </p>
            ),
            type: "content",
            className: "col-12",
          },
        ],
      },
    ],
  },
];